import type { UseTranslationResponse } from 'react-i18next';
import { useTranslation } from 'react-i18next';

const namespace = 'features';
export const keyPrefix = 'search_by_external_id';

export const useSearchByExternalIdTranslation = (): UseTranslationResponse<typeof namespace, typeof keyPrefix> => {
  return useTranslation(namespace, { keyPrefix });
};

export const ruRu = ({
  [keyPrefix]: {
    button: 'Искать персону',
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    button: 'Search person',
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    button: 'Buscar persona',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    button: 'Buscar pessoa',
  },
}) as Record<string, unknown>;
